export interface SortOption {
  text: string;
  value?: string;
  direction?: string;
}

export const sortOptions = [
  { text: "Recently Added", value: "data.startDate", direction: "desc" },
  { text: "Most Popular", value: "percentageSold", direction: "desc" },
  { text: "Price (Low → High)", value: "priceUsdCents", direction: "asc" },
  { text: "Price (High → Low)", value: "priceUsdCents", direction: "desc" },
  {
    text: "Artist Name (A → Z)",
    value: "creator.sortableName",
    direction: "asc",
  },
  {
    text: "Artist Name (Z → A)",
    value: "creator.sortableName",
    direction: "desc",
  },
  { text: "Vault Name (A → Z)", value: "sortableName", direction: "asc" },
  { text: "Vault Name (Z → A)", value: "sortableName", direction: "desc" },
];
